export const EXTRA_FOLLOWUP_QUESTIONS = [
    {
      id: 999999999, 
      workTypeID: 115,
      activityID: 417,
      fieldName: 'isTechRequiredOnsiteForTheDigYes',
      displayOrder: 11,
      controlType: 'TEXT',
      name_en: 'Reason',
      name_fr: 'Raison',
      tooltip_en: 'Reason a technician is required on the dig site',
      tooltip_fr: 'Raison pour laquelle un technicien est requis sur le chantier de creusement',
      mandatory: false,
      metadata: `{
        "dependsOn":[{"field":"Is a tech required onsite for the dig?","op":"eq","value":"0"}],
        "mandatoryWhen":[{"field":"Is a tech required onsite for the dig?","op":"eq","value":"0"}],
        "clearWhenHidden":true
      }`,
    },
    {
      id: 999999998, 
      workTypeID: 115,
      activityID: 417,
      fieldName: 'isWorkSiteAccessibleByVehiclesPartial',
      displayOrder: 15,
      controlType: 'TEXT',
      name_en: 'Comment',
      name_fr: 'Commentaire',
      tooltip_en:
        'Comment to indicate why the work site is only partially accessible by vehicles',
      tooltip_fr:
        'Commentaire pour indiquer pourquoi le chantier n’est que partiellement accessible aux véhicules',
      mandatory: false,
      metadata: `{
        "dependsOn":[{"field":"Is work site accessible by vehicles?","op":"eq","value":"Partial "}],
        "mandatoryWhen":[{"field":"Is work site accessible by vehicles?","op":"eq","value":"Partial "}],
        "clearWhenHidden":true
      }`,}
  ];